import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 5.7A1.7 1.7 0 0 1 4.7 4h10.6A1.7 1.7 0 0 1 17 5.7v8.209a1.7 1.7 0 0 1-1.7 1.7h-5.104l-3.77 2.29a.7.7 0 0 1-1.064-.599v-1.691H4.7a1.7 1.7 0 0 1-1.7-1.7V5.7Zm1.7-.3a.3.3 0 0 0-.3.3v8.209a.3.3 0 0 0 .3.3h1.362a.7.7 0 0 1 .7.7v1.147l2.875-1.745a.7.7 0 0 1 .363-.102h5.3a.3.3 0 0 0 .3-.3V5.7a.3.3 0 0 0-.3-.3H4.7Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 8.401a.7.7 0 0 1 .7.7v2.739a.7.7 0 1 1-1.4 0V9.101a.7.7 0 0 1 .7-.7Zm3.635-.428L9.584 9.69v1.431l.422.352a.09.09 0 0 0 .054.02h2.185l.443-1.55a.16.16 0 0 0-.02-.132l-.001-.001a.146.146 0 0 0-.122-.066H11.6a.7.7 0 0 1-.7-.7v-.997a.144.144 0 0 0-.068-.12m-.198.046a.144.144 0 0 1 .198-.047l-.198.047ZM9.443 7.24a1.544 1.544 0 0 1 2.858.8v.304h.244a1.555 1.555 0 0 1 1.488 1.983l-.457 1.601c-.163.57-.684.964-1.277.964H10.06c-.345 0-.68-.12-.946-.34l-.001-.002-.677-.562a.7.7 0 0 1-.252-.538V9.492a.7.7 0 0 1 .103-.365L9.443 7.24Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=FeedbackIcon20.js.map